import { ReactNode } from "react";
import { Flex } from "@chakra-ui/react";

import { ChakraText } from "../ChakraText";
import { Modal } from "./Modal";
import { Button } from "../Button";
import { CustomColorScheme } from "../Button/types/CustomColorScheme";

interface IProps {
  onClose: () => void;
  onAccept: () => void;
  isOpen: boolean;
  modalBody: ReactNode;
  isLoading?: boolean;
}

const ConfirmationModal = ({
  onClose,
  isOpen,
  modalBody,
  onAccept,
  isLoading,
}: IProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={<ChakraText>Potwierdzenie operacji</ChakraText>}
      modalFooterButtons={
        <Flex w="100%">
          <Button
            customColorScheme={CustomColorScheme.Green}
            onClick={onAccept}
            isLoading={isLoading}
            disabled={isLoading}
            w="250px"
            mx="auto"
            id="confirm-operation-btn"
          >
            Potwierdź
          </Button>
        </Flex>
      }
    >
      {modalBody}
    </Modal>
  );
};

export { ConfirmationModal };
